import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

export default function NotFoundPage() {
  useEffect(() => {
    const title = "Page not found | SurensInffotek";
    const descriptionText = "This page is not on the SurensInffotek website.";
    const path = (window.location.pathname.replace(/\/+$/, "") || "/");
    const url = `https://surensinffotek.com${path}/`;
    const description = document.querySelector('meta[name="description"]');
    const robots = document.querySelector('meta[name="robots"]');
    const canonical = document.querySelector('link[rel="canonical"]');
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDescription = document.querySelector('meta[property="og:description"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const previous = {
      title: document.title,
      description: description && description.getAttribute("content"),
      robots: robots && robots.getAttribute("content"),
      canonical: canonical && canonical.getAttribute("href"),
      ogTitle: ogTitle && ogTitle.getAttribute("content"),
      ogDescription: ogDescription && ogDescription.getAttribute("content"),
      ogUrl: ogUrl && ogUrl.getAttribute("content")
    };
    document.title = title;
    if (description) description.setAttribute("content", descriptionText);
    if (robots) robots.setAttribute("content", "noindex, follow");
    if (canonical) canonical.setAttribute("href", url);
    if (ogTitle) ogTitle.setAttribute("content", title);
    if (ogDescription) ogDescription.setAttribute("content", descriptionText);
    if (ogUrl) ogUrl.setAttribute("content", url);
    return () => {
      document.title = previous.title;
      if (description && previous.description) description.setAttribute("content", previous.description);
      if (robots && previous.robots) robots.setAttribute("content", previous.robots);
      if (canonical && previous.canonical) canonical.setAttribute("href", previous.canonical);
      if (ogTitle && previous.ogTitle) ogTitle.setAttribute("content", previous.ogTitle);
      if (ogDescription && previous.ogDescription) ogDescription.setAttribute("content", previous.ogDescription);
      if (ogUrl && previous.ogUrl) ogUrl.setAttribute("content", previous.ogUrl);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Page not found | SurensInffotek</title>
        <meta
          name="description"
          content="This page is not on the SurensInffotek website."
        />
      </Helmet>
      <main className="bg-white text-slate-800">
        <article className="mx-auto max-w-3xl px-5 py-16 sm:px-8 sm:py-24">
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-sky-600">
            SurensInffotek
          </p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight text-slate-950 sm:text-4xl">
            Page not found
          </h1>
          <p className="mt-6 text-base leading-8 text-slate-700">
            The address you opened is not a page on this website.
          </p>
          <p className="mt-8">
            <a
              href="/"
              className="inline-flex items-center rounded-lg bg-sky-700 px-5 py-3 text-sm font-semibold text-white"
            >
              Back to Home
            </a>
          </p>
        </article>
      </main>
    </>
  );
}
